import { render, staticRenderFns } from "./DriverDetails.vue?vue&type=template&id=52985f73&scoped=true"
import script from "./DriverDetails.vue?vue&type=script&lang=js"
export * from "./DriverDetails.vue?vue&type=script&lang=js"
import style0 from "./DriverDetails.vue?vue&type=style&index=0&id=52985f73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52985f73",
  null
  
)

export default component.exports